import operationTypesMap from 'constants/operationTypesMap';
import writeOffIds from './writeOffActionKindIds';
import actionKindMap from './actionKindMap';

export default [
  {
    label: 'Все операции',
    value: -1,
    filterFn: () => true,
  },
  {
    label: 'Оплата',
    value: 1,
    filterFn: (operationObject) =>
      operationObject.operation.type === operationTypesMap.payment &&
      !~writeOffIds.indexOf(operationObject.actionKind) &&
      !operationObject.operation.isOverpayment,
  },
  {
    label: 'Начисление',
    value: 2,
    filterFn: (operationObject) =>
      operationObject.operation.type === operationTypesMap.accrual &&
      !~writeOffIds.indexOf(operationObject.actionKind) &&
      !operationObject.operation.isOverpayment,
  },
  {
    label: 'Списание',
    value: 3,
    filterFn: (operationObject) => ~writeOffIds.indexOf(operationObject.actionKind),
  },
  {
    label: 'Зачет переплаты',
    value: 4,
    filterFn: (operationObject) => operationObject.actionKind === actionKindMap.credit,
  },
  {
    label: 'Возврат переплаты',
    value: 5,
    filterFn: (operationObject) => operationObject.actionKind === actionKindMap.refund,
  },
];
